<script>
import TgIconButton from "@/abc-dsk/components/IconButton/TgIconButton.vue";
import IconSpeaker from "@/components/icons/IconSpeaker.vue";

export default {
  name: "AudioButton",
  components: {
    IconSpeaker,
    TgIconButton
  },
  props: {
    audioUrl: {
      type: String,
      required: true
    },
    iconClass: {
      type: [String, Array, Object],
      default: null
    }
  },
  data() {
    return {
      audioElement: null
    };
  },
  methods: {
    play() {
      if (this.audioElement === null) {
        this.audioElement = new Audio(this.audioUrl);
      }

      this.audioElement.play();
    }
  }
};
</script>

<template>
  <TgIconButton color="secondary" @click.stop="play()">
    <IconSpeaker :class="iconClass" role="presentation" />
  </TgIconButton>
</template>
